import React from 'react';
import { Check } from 'lucide-react';
import { REEL_CREATOR_STAGES } from '../../lib/reelCreatorConfig';

export default function ReelCreatorProgress({ current = 0 }) {
  return (
    <ol aria-label="Reel creation progress" className="reel-progress grid grid-cols-5 gap-1">
      {REEL_CREATOR_STAGES.map((stage, index) => {
        const complete = index < current;
        const active = index === current;
        return (
          <li key={stage} aria-current={active ? 'step' : undefined} className="min-w-0 text-center">
            <div className={`mx-auto flex h-8 w-8 items-center justify-center rounded-full border text-xs font-bold ${
              complete ? 'border-green-400 bg-green-500 text-gray-950' : active ? 'border-purple-400 bg-purple-500 text-white' : 'border-gray-700 bg-gray-900 text-gray-500'
            }`}>
              {complete ? <Check size={15} aria-hidden="true" /> : index + 1}
            </div>
            <span className={`mt-1 block truncate text-[10px] leading-4 sm:text-xs ${active ? 'text-white' : 'text-gray-500'}`}>{stage}</span>
          </li>
        );
      })}
    </ol>
  );
}

